export default __webpack_public_path__ + "static/media/info.d9c8a125.svg";